import type { ShiftCost } from '../../models/costs.types';

export const today = () => new Date().toISOString().slice(0, 10);

export const additionalLabels: Record<NonNullable<ShiftCost['additionalCode']>, string> = {
  restaurant_deduction: 'ניכוי מסעדה לשעת נוכחות',
  tip_grade: 'אחוז דרגת טיפ לפי תפקיד',
  minimum_completion: 'השלמה למינימום לפי תפקיד',
  trainee_deduction: 'ניכוי מתלמד',
};

export const unitLabels: Record<NonNullable<ShiftCost['type']>, string> = {
  hourly: 'שעתי',
  daily: 'יומי',
  weekend: 'סוף שבוע',
  monthly: 'חודשי',
};
